// extracted by mini-css-extract-plugin
export var accordion = "NavigationPanel-module--accordion--9a339";
export var accordionPanel = "NavigationPanel-module--accordion-panel--a17ac";
export var accordionPanelLayout = "NavigationPanel-module--accordion-panel-layout--284f7";
export var active = "NavigationPanel-module--active--cd9cd";
export var altaccent = "NavigationPanel-module--altaccent--07454";
export var arrow = "NavigationPanel-module--arrow--6bfde";
export var bright = "NavigationPanel-module--bright--56e5a";
export var button = "NavigationPanel-module--button--56c3b";
export var content = "NavigationPanel-module--content--e00d0";
export var header = "NavigationPanel-module--header--68b64";
export var heading = "NavigationPanel-module--heading--77068";
export var layout = "NavigationPanel-module--layout--f0bcd";
export var lead = "NavigationPanel-module--lead--3a762";
export var link = "NavigationPanel-module--link--0151a";
export var list = "NavigationPanel-module--list--831f7";
export var logo = "NavigationPanel-module--logo--28c9a";
export var menuArea = "NavigationPanel-module--menu-area--51744";
export var navigation = "NavigationPanel-module--navigation--80fe3";
export var socket = "NavigationPanel-module--socket--f6293";
export var space = "NavigationPanel-module--space--8779e";
export var stretch = "NavigationPanel-module--stretch--3c7c0";
export var tag = "NavigationPanel-module--tag--e61b9";
export var toggle = "NavigationPanel-module--toggle--f8d14";
export var toggleIcon = "NavigationPanel-module--toggle-icon--15902";